module.exports = __webpack_public_path__ + "static/media/kim.e687b04f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/kim.jpg
// module id = 236
// module chunks = 0